// extracted by mini-css-extract-plugin
export default {"modalOverlay":"GD-z","modalContent":"HD-z","header":"ID-z","close":"JD-z"};